import { Component, Input } from '@angular/core';
import { BaseCellComponent } from '../base-cell.component';
import { ViewManager } from 'src/app/board/pages/admin/admin-components/custom-views-config/view-builder/models/view-builder.models';

@Component({
  selector: 'bhub-pdf-page-break-cell',
  standalone: false,
  templateUrl: './pdf-page-break-cell.component.html',
  styleUrls: ['./pdf-page-break-cell.component.scss']
})
export class PdfPageBreakCellComponent extends BaseCellComponent {
  @Input() viewManager: ViewManager | null = null;

  protected initializeCell(): void {
    // No initialization needed for page break
  }

  protected onCellOrDataChange(): void {
    // No data to update
  }

  protected onCellUpdate(): void {
    // No updates needed
  }

  protected onDataSet(data: any): void {
    // No data binding
  }
}
